<template>
  <div class="mgb-20">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in breadList"
        :key="index"
        :to="{ path: item.path }"
      >
        <i v-if="index == 0" class="el-icon-s-home"></i>
        {{ getBreadcrumbTitle(item) }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  // name: "breadcrumbs",
  computed: {
    // 动态路由的 name 是内部唯一标识；界面统一优先展示菜单标题。
    breadList() {
      return this.$route.matched.filter((item) => this.getBreadcrumbTitle(item));
    }
  },
  methods: {
    getBreadcrumbTitle(item) {
      const metaTitle = item && item.meta && item.meta.title;
      if (typeof metaTitle === "string" && metaTitle) {
        return metaTitle;
      }

      const routeName = item && item.name;
      // 菜单路由的内部 name 绝不能直接暴露到页面。
      return /^menu(?:-container)?-/.test(routeName || "") ? "" : routeName || "";
    }
  }
};
</script>

<style scoped lang="scss">
/* 面包屑：element-theme 未纳入 el-breadcrumb，故在本组件 scoped 块内主题化 */
::v-deep .el-breadcrumb {
  font-size: 14px;
  line-height: 1;
}
::v-deep .el-breadcrumb__inner,
::v-deep .el-breadcrumb__inner.is-link {
  color: var(--text-muted);
  font-weight: 500;
  transition: color 0.2s ease;
}
::v-deep .el-breadcrumb__inner.is-link:hover {
  color: var(--accent);
}
::v-deep .el-breadcrumb__separator {
  color: var(--text-muted);
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: var(--text-main);
  cursor: default;
}
::v-deep .el-icon-s-home {
  margin-right: 4px;
  color: var(--accent);
}
</style>
